import React from "react";

import { useIntl } from "react-intl";

import { Tooltip } from "ds/Tooltip";

type Props = {
  canCreateBranch: boolean;
  tooltipId: string;
  children: React.JSX.Element;
};

const BranchTooltip = ({ canCreateBranch, tooltipId, children }: Props) => {
  const intl = useIntl();

  return canCreateBranch ? (
    children
  ) : (
    <Tooltip
      tooltip={intl.formatMessage({ id: tooltipId })}
      analyticId={tooltipId}
    >
      {children}
    </Tooltip>
  );
};

export default BranchTooltip;
